import { Game } from '../game.model';
import { Player } from '../player.model';

export class Left {
  game: Game;
  player: Player;
}
